module.exports = {
  equilibrium: require("./equilibrium.json"),
  equilibriumNext: require("./equilibrium.next.json"),
  genshiro: require("./genshiro.json"),
};
